import React,{ useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Form,Table, Button } from 'react-bootstrap';
import { DatePickerW,DatePickerMonthW } from '../../Components/Components';
import moment from 'moment';
import { AuthContext } from '../../auth/AuthContext';
import { number_format } from '../../utils/Utils';
import Skeleton from 'react-loading-skeleton';

export const TablePendientes = (size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 }) => {

    const { usuario } = useContext(AuthContext);
    const currentMonth = moment().format("MMMM");
    const currentYear = new Date().getFullYear();
    const [search, setSearch] = useState("");
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(
        moment().month(currentMonth).subtract(1, "month").format("M")
    );
    const [data,setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [loadPolizas,setLoadPolizas] = useState(false);

    useEffect(()=>{
        setLoad(true)
        getPagosPendientes();
    },[])

    useEffect(() => {
        if (loadPolizas) {
          setLoad(true);
          getPagosPendientes();
        }
    }, [loadPolizas]);

    const handleClickPagar = (poliza="4092186382",vin="75528",correo="a@correo.com") => {
        const vinm = vin.substring(vin.length - 5)
        const polizam = poliza.padStart(10,'0')
        window.open(`https://wsoft.com.mx/acyn/corp/pasarelaPagos.php?poliza=${polizam}&vin=${vinm}&correo=${correo}`,"_blank").focus();
    }

    if (load) {
        return (
          <Col
            xs={size.xs}
            sm={size.sm}
            md={size.md}
            lg={size.lg}
            xl={size.xl}
            xxl={size.xxl}
            className="mb-3"
          >
            <div
              className="ws_box"
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
              <Container fluid>
                <div className="ws_box_header mb-3">
                  <div className="d-flex justify-content-start align-items-end">
                    <div>
                      <h2 className="ws_table_agente_title pb-0 mb-2">
                        Pagos pendientes
                      </h2>
                    </div>
                  </div>
                </div>
                <Skeleton width="100%" height={400} />
              </Container>
            </div>
          </Col>
        );
    }

    return(
        <Col xs={12} md={12} className="mb-3">
            <div className='ws_box' style={{paddingTop:'1rem',paddingBottom:'1rem'}}>
                <Container fluid>
                    <div className='ws_box_header mb-3'>
                        <div className="d-flex flex-column justify-content-center align-items-start">
                            <div>
                                <h2 className="ws_table_agente_title pb-0 mb-2">
                                    Pagos pendientes
                                </h2>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <DatePickerW
                                onChange={(e) => {
                                    setYear(e.target.value); 
                                    setLoadPolizas(true);
                                }}
                                year={currentYear}
                                selected={year}
                                />
                                <DatePickerMonthW
                                className="ms-2"
                                onChange={(e) => {
                                    setMonth(e.target.value);
                                    setLoadPolizas(true);
                                }}
                                selected={month}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-column justify-content-between align-items-end">
                            <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                                <Form>
                                    <Form.Control
                                        type="search"
                                        placeholder="Buscar"
                                        className="ws_input"
                                        onChange={(e) => {
                                        setSearch(e.target.value);
                                        }}
                                    />
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: 450 }}>
                        <Table striped bordered hover size="sm" className="ws_tabla" style={{borderRadius:'0px'}}>
                            <thead
                            style={{
                                backgroundColor: "#0a93af",
                                color: "#fff",
                                fontSize: ".9rem",
                            }}
                            >
                            <tr>
                                <th align="left" className="ps-3">Número de póliza</th>
                                {/* <th align="left" className="ps-3">Agente</th> */}
                                <th align="left" className="ps-3">Clave del agente</th>
                                <th align="left" className="ps-3">Fecha de inicio</th>
                                <th align="left" className="ps-3">Fecha fin</th>
                                <th align="left" className="ps-3">Vehículo</th>
                                <th align="left" className="ps-3">Número de serie</th>
                                <th align="left" className="ps-3">Uso</th>
                                <th align="left" className="ps-3">Servicio</th>
                                <th align="left" className="ps-3">Paquete</th>
                                <th align="left" className="ps-3">Prima total</th>
                                {/* <th align="left" className="ps-3">% de descuento</th> */}
                                <th align="left" className="ps-3">Opciones</th>
                            </tr>
                            </thead>
                            <tbody style={{ fontSize: ".9rem" }}>
                                {
                                data.length > 0 ? (
                                    data.map((t,e) => {
                                        if (
                                            search === "" ||
                                            (t.poliza && t.poliza.toString().indexOf(search) !== -1) ||
                                            (t.agente && t.agente.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                            (t.descripcion && t.descripcion.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                            (t.cobertura && t.cobertura.toLowerCase().indexOf(search.toLowerCase()) !== -1)
                                            ) {
                                            return(
                                                <tr key={e}>
                                                    <td className="ps-2 text-left">
                                                        {t.poliza}
                                                    </td>
                                                    <td className="text-center">
                                                        {t.agente}
                                                    </td>
                                                    <td className="text-center">
                                                        {moment(t.fecha_inicio).format("DD/MM/YYYY")}
                                                    </td>
                                                    <td className="text-center">
                                                        {moment(t.fecha_fin).format("DD/MM/YYYY")}
                                                    </td>
                                                    <td className="ps-2 text-left">
                                                        {t.descripcion}
                                                    </td>
                                                    <td className="ps-2 text-left">
                                                        {t.serie}
                                                    </td>
                                                    <td className="text-center">
                                                        {t.uso}
                                                    </td>
                                                    <td className="text-center">
                                                        {t.servicio}
                                                    </td>
                                                    <td className="text-center">
                                                        {t.paquete_seleccionado}
                                                    </td>
                                                    <td className="ps-2 text-left">
                                                        $ {t.prima_total}
                                                    </td>
                                                    {/* <td className="text-left">
                                                        {t.agente}
                                                    </td> */}
                                                    <td className="text-center">
                                                        <Button className="btn-sm ws_btn_secundary"
                                                        style={{
                                                            borderRadius:5,
                                                            width: '90%'
                                                        }}
                                                        onClick={
                                                            () => {
                                                                handleClickPagar(t.poliza,t.serie)
                                                            }
                                                        }
                                                        >Pagar</Button>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                )
                                : (
                                    <tr className="text-center">
                                        <td colSpan="10">
                                            <p style={{ fontSize: "1rem" }}>No hay datos disponibles</p>
                                        </td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </Table>
                    </div>
                </Container>
            </div>
        </Col>
    )

    function getPagosPendientes() {
        const data = {
          id_login: usuario.id_usuario,
          year: year,
          month : month
      };
      fetch("https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getPolizasPorRenovar",
          {
              method: "POST",
              mode: "cors",
              body: JSON.stringify(data),
          }
          ) 
          .then((response) => response.json())
          .then((data) => {
              const newData = data.list
              newData.push({
                "poliza": "4092186382",
                "asegurado": "JACOBO ALFREDO GONZALEZ FUENTES",
                "fecha_inicio": "2021-05-12",
                "fecha_fin": "2022-05-12",
                "fecha_vig_recibo": "2022-04-12",
                "descripcion": "VW JETTA A7 TRENDLINE 4P L4 1.4T TSI ABS BA AC R16",
                "modelo": 2020,
                "agente": "74985",
                "prima_total": "6549.22",
                "uso": "1",
                "servicio": "1",
                "paquete_seleccionado": "AMPLIA",
                "serie": "3VWKP6BU0LM075528",
                "nombre": "JACOBO ALFREDO",
                "paterno": "GONZALEZ",
                "materno": "FUENTES",
                "rfc_asegurado": "GOFJ741106391",
                "fecha_nacimiento": "1974-11-06",
                "cp": "24158",
                "amis": "5152",
                "correo": "hola@segurocotizas.com",
                "telefono": "",
                "dir_aseg_calle": "CONSTELACION CAMALEO",
                "estado": "CAMPECHE",
                "colonia": "FRACC EL POTRERO",
                "poblacion": "CARMEN",
                "tipo_persona": 1
              })
              setLoadPolizas(false)
              setData(data.list)
              setLoad(false)
          });
      }
}

export const TableRenovaciones = (size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 }) => {

    const { usuario } = useContext(AuthContext);
    const currentMonth = moment().format("MMMM");
    const currentYear = new Date().getFullYear();
    const [search, setSearch] = useState("");
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(
        moment().month(currentMonth).subtract(1, "month").format("M")
    );
    const [data,setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [loadPolizas,setLoadPolizas] = useState(false);

    useEffect(()=>{
        setLoad(true)
        getPolizasPorRenovar();
    },[])

    useEffect(() => {
        if (loadPolizas) {
          setLoad(true);
          getPolizasPorRenovar();
        }
    }, [loadPolizas]);

    const handleClickRenovar = (data) => {
        data.app_id_secret = "Mx19au9Dh5-OTj555VeDG-UeQoAySCm0-jVJhgk3"
        const newData = {...data}
        const paquete = newData.paquete_seleccionado.toLowerCase();

        if(paquete.includes("amplia") || paquete.includes("limitada") || paquete.includes("responsabilidad civi")){
            if(paquete.includes("amplia")){
                newData.paquete_seleccionado = 1
            }
            if(paquete.includes("limitada")){
                newData.paquete_seleccionado = 3
            }
            if(paquete.includes("responsabilidad civ")){
                newData.paquete_seleccionado = 4
            }
        }else{
            alert("Este tipo de cobertura no esta disponible")
        }

        fetch('https://mercedes.wsoft.com.mx/WSDL/recuperar_polizas.php?opt=recuperarPolizaByAppIdSecret',
        {
            method: "POST",
            mode: 'cors',
            body : JSON.stringify(newData)
        }
        )
        .then( response => response.json())
        .then( data => {
            console.log(data)
            // data.archivos.map((t,e) => {
            //     window.open(`${t.url}`,"_blank").focus();
            // })
        })
    }

    if (load) {
        return (
          <Col
            xs={size.xs}
            sm={size.sm}
            md={size.md}
            lg={size.lg}
            xl={size.xl}
            xxl={size.xxl}
            className="mb-3"
          >
            <div
              className="ws_box"
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
              <Container fluid>
                <div className="ws_box_header mb-3">
                  <div className="d-flex justify-content-start align-items-end">
                    <div>
                      <h2 className="ws_table_agente_title pb-0 mb-2">
                        Renovaciones
                      </h2>
                    </div>
                  </div>
                </div>
                <Skeleton width="100%" height={400} />
              </Container>
            </div>
          </Col>
        );
    }

    return(
    <Col xs={12} md={12} className="mb-3">
        <div className='ws_box' style={{paddingTop:'1rem',paddingBottom:'1rem'}}>
            <Container fluid>
                <div className='ws_box_header mb-3'>
                    <div className="d-flex flex-column justify-content-center align-items-start">
                        <div>
                            <h2 className="ws_table_agente_title pb-0 mb-2">
                                Renovaciones
                            </h2>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <DatePickerW
                            onChange={(e) => {
                                setYear(e.target.value);
                                setLoadPolizas(true);
                            }}
                            year={currentYear}
                            selected={year}
                            />
                            <DatePickerMonthW
                            className="ms-2"
                            onChange={(e) => {
                                setMonth(e.target.value);
                                setLoadPolizas(true);
                            }}
                            selected={month}
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between align-items-end">
                        <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                            <Form>
                                <Form.Control
                                    type="search"
                                    placeholder="Buscar"
                                    className="ws_input"
                                    onChange={(e) => {
                                    setSearch(e.target.value);
                                    }}
                                />
                            </Form>
                        </div>
                    </div>
                </div>
                <div className="table-responsive" style={{ maxHeight: 450 }}>
                    <Table striped bordered hover size="sm" className="ws_tabla" style={{borderRadius:'0px'}}>
                        <thead
                        style={{
                            backgroundColor: "#0a93af",
                            color: "#fff",
                            fontSize: ".9rem",
                        }}
                        >
                        <tr>
                            <th align="left" className="ps-3">Número de póliza</th>
                            {/* <th align="left" className="ps-3">Agente</th> */}
                            <th align="left" className="ps-3">Clave del agente</th>
                            <th align="left" className="ps-3">Fecha de inicio</th>
                            <th align="left" className="ps-3">Fecha fin</th>
                            <th align="left" className="ps-3">Vehículo</th>
                            <th align="left" className="ps-3">Uso</th>
                            <th align="left" className="ps-3">Servicio</th>
                            <th align="left" className="ps-3">Paquete</th>
                            <th align="left" className="ps-3">Prima total</th>
                            {/* <th align="left" className="ps-3">% de descuento</th> */}
                            <th align="left" className="ps-3">Opciones</th>
                        </tr>
                        </thead>
                        <tbody style={{ fontSize: ".9rem" }}>
                            {
                            data.length > 0 ? (
                                data.map((t,e) => {
                                    if (
                                        search === "" ||
                                        (t.poliza && t.poliza.toString().indexOf(search) !== -1) ||
                                        (t.agente && t.agente.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                        (t.descripcion && t.descripcion.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                        (t.cobertura && t.cobertura.toLowerCase().indexOf(search.toLowerCase()) !== -1)
                                        ) {
                                        return(
                                            <tr key={e}>
                                                <td className="ps-2 text-left">
                                                    {t.poliza}
                                                </td>
                                                <td className="text-center">
                                                    {t.agente}
                                                </td>
                                                <td className="text-center">
                                                    {moment(t.fecha_inicio).format("DD/MM/YYYY")}
                                                </td>
                                                <td className="text-center">
                                                    {moment(t.fecha_fin).format("DD/MM/YYYY")}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    {t.descripcion}
                                                </td>
                                                <td className="text-center">
                                                    {t.uso}
                                                </td>
                                                <td className="text-center">
                                                    {t.servicio}
                                                </td>
                                                <td className="text-center">
                                                    {t.paquete_seleccionado}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    $ {t.prima_total}
                                                </td>
                                                {/* <td className="text-left">
                                                    {t.agente}
                                                </td> */}
                                                <td className="text-center">
                                                    <Button 
                                                    className="btn-sm ws_btn_secundary"
                                                    style={{
                                                        borderRadius: 5,
                                                        width: '90%'
                                                    }}
                                                    onClick= {
                                                        (e) =>{
                                                            handleClickRenovar(t);
                                                        }
                                                    }
                                                    >Renovar</Button>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })
                            )
                            : (
                                <tr className="text-center">
                                    <td colSpan="10">
                                        <p style={{ fontSize: "1rem" }}>No hay datos disponibles</p>
                                    </td>
                                </tr>
                            )
                            }
                        </tbody>
                    </Table>
                </div>
            </Container>
        </div>
    </Col>
    )

    function getPolizasPorRenovar() {
      const data = {
        id_login: usuario.id_usuario,
        year: year,
        month : month
    };
    fetch("https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getPolizasPorRenovar",
        {
            method: "POST",
            mode: "cors",
            body: JSON.stringify(data),
        }
        ) 
        .then((response) => response.json())
        .then((data) => {
            setLoadPolizas(false)
            setData(data.list)
            setLoad(false)
        });
    }
}

export const TableCancelaciones = (size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 }) => {

    const { usuario } = useContext(AuthContext);
    const currentMonth = moment().format("MMMM");
    const currentYear = new Date().getFullYear();
    const [search, setSearch] = useState("");
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(
        moment().month(currentMonth).subtract(1, "month").format("M")
    );
    const [data,setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [loadPolizas,setLoadPolizas] = useState(false);

    useEffect(()=>{
        setLoad(true)
        getPolizasCanceladas();
    },[])

    useEffect(() => {
        if (loadPolizas) {
          setLoad(true);
          getPolizasCanceladas();
        }
    }, [loadPolizas]);

    if (load) {
        return (
          <Col
            xs={size.xs}
            sm={size.sm}
            md={size.md}
            lg={size.lg}
            xl={size.xl}
            xxl={size.xxl}
            className="mb-3"
          >
            <div
              className="ws_box"
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
              <Container fluid>
                <div className="ws_box_header mb-3">
                  <div className="d-flex justify-content-start align-items-end">
                    <div>
                      <h2 className="ws_table_agente_title pb-0 mb-2">
                        Cancelaciones
                      </h2>
                    </div>
                  </div>
                </div>
                <Skeleton width="100%" height={400} />
              </Container>
            </div>
          </Col>
        );
    }

    return(
        <Col xs={12} md={12} className="mb-3">
        <div className='ws_box' style={{paddingTop:'1rem',paddingBottom:'1rem'}}>
            <Container fluid>
                <div className='ws_box_header mb-3'>
                    <div className="d-flex flex-column justify-content-center align-items-start">
                        <div>
                            <h2 className="ws_table_agente_title pb-0 mb-2">
                                Cancelaciones
                            </h2>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <DatePickerW
                            onChange={(e) => {
                                setYear(e.target.value);
                                setLoadPolizas(true);
                            }}
                            year={currentYear}
                            selected={year}
                            />
                            <DatePickerMonthW
                            className="ms-2"
                            onChange={(e) => {
                                setMonth(e.target.value);
                                setLoadPolizas(true);
                            }}
                            selected={month}
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between align-items-end">
                        <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                            <Form>
                                <Form.Control
                                    type="search"
                                    placeholder="Buscar"
                                    className="ws_input"
                                    onChange={(e) => {
                                    setSearch(e.target.value);
                                    }}
                                />
                            </Form>
                        </div>
                    </div>
                </div>
                <div className="table-responsive" style={{ maxHeight: 450 }}>
                    <Table striped bordered hover size="sm" className="ws_tabla" style={{borderRadius:'0px'}}>
                        <thead
                        style={{
                            backgroundColor: "#0a93af",
                            color: "#fff",
                            fontSize: ".9rem",
                        }}
                        >
                        <tr>
                            <th align="left" className="ps-3">Número de póliza</th>
                            <th align="left" className="ps-3">Nombre del asegurado</th>
                            <th align="left" className="ps-3">Fecha de inicio</th>
                            <th align="left" className="ps-3">Fecha fin</th>
                            {/* <th align="left" className="ps-3">Agente</th> */}
                            <th align="left" className="ps-3">Clave del agente</th>
                            <th align="left" className="ps-3">Vehículo</th>
                            <th align="left" className="ps-3">Número de serie</th>
                            <th align="left" className="ps-3">Motivo</th>
                            <th align="left" className="ps-3">Prima total</th>
                            {/* <th align="left" className="ps-3">Opciones</th> */}
                        </tr>
                        </thead>
                        <tbody style={{ fontSize: ".9rem" }}>
                        {
                            data.length > 0 ? (
                                data.map((t,e) => {
                                    if (
                                        search === "" ||
                                        (t.poliza && t.poliza.toString().indexOf(search) !== -1) ||
                                        (t.asegurado && t.asegurado.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                        (t.agente && t.agente.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                                        (t.descripcion && t.descripcion.toLowerCase().indexOf(search.toLowerCase()) !== -1) || 
                                        (t.serie && t.serie.toLowerCase().indexOf(search.toLowerCase()) !== -1) || 
                                        (t.descripcion_status && t.descripcion_status.toLowerCase().indexOf(search.toLowerCase()) !== -1)
                                        ) {
                                        return(
                                            <tr key={e}>
                                                <td className="ps-2 text-left">
                                                    {t.poliza}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    {t.asegurado}
                                                </td>
                                                <td className="text-center">
                                                    {moment(t.fecha_inicio).format("DD/MM/YYYY")}
                                                </td>
                                                <td className="text-center">
                                                    {moment(t.fecha_fin).format("DD/MM/YYYY")}
                                                </td>
                                                <td className="text-center">
                                                    {t.agente}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    {t.descripcion}
                                                </td>
                                                <td className="text-center">
                                                    {t.serie}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    {t.descripcion_status}
                                                </td>
                                                <td className="ps-2 text-left">
                                                    $ {t.prima_total}
                                                </td>
                                                {/* <td className="text-left">
                                                    {t.agente}
                                                </td> */}
                                                {/* <td className="text-center">
                                                    <Button 
                                                    className="btn-sm ws_btn_secundary"
                                                    style={{
                                                        borderRadius: 5,
                                                        width: '90%'
                                                    }}
                                                    >Cancelar</Button>
                                                </td> */}
                                            </tr>
                                        )
                                    }
                                })
                            )
                            : (
                                <tr className="text-center">
                                    <td colSpan="10">
                                        <p style={{ fontSize: "1rem" }}>No hay datos disponibles</p>
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
                </div>
            </Container>
        </div>
    </Col>
    )

    function getPolizasCanceladas() {
        const data = {
          id_login: usuario.id_usuario,
          year: year,
          month : month
      };
      fetch("https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getPolizasCanceladas",
          {
              method: "POST",
              mode: "cors",
              body: JSON.stringify(data),
          }
          ) 
          .then((response) => response.json())
          .then((data) => {
              setLoadPolizas(false)
              setData(data.list)
              setLoad(false)
          });
      }
}